import axios from 'axios';
import { API_BASE_URL } from '../config';

const coaService = {
  getAccounts: async () => {
    const response = await axios.get(`${API_BASE_URL}/coa/`);
    return response.data;
  },
  getAccount: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/coa/${id}`);
    return response.data;
  },
  createAccount: async (data) => {
    const response = await axios.post(`${API_BASE_URL}/coa/`, data);
    return response.data;
  },
  updateAccount: async (id, data) => {
    const response = await axios.put(`${API_BASE_URL}/coa/${id}`, data);
    return response.data;
  },
  deleteAccount: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/coa/${id}`);
    return response.data;
  },
};

export default coaService;
